import { render, staticRenderFns } from "./PositioningForm.vue?vue&type=template&id=aad697d6&"
import script from "./PositioningForm.vue?vue&type=script&lang=js&"
export * from "./PositioningForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports